import { IAccount } from "@wingspanhq/users/dist/lib/interfaces/account";
import { INVOICE_ACCOUNT_NAME } from "../../Invoices/utils";
import { ICheckbookCard } from "@wingspanhq/payments/dist/interfaces";

export const getAccountName = (account: IAccount): string => {
  const { institution, subType, mask, name } = account;
  let formattedSubType;
  if (subType) {
    formattedSubType = subType.replace(/([A-Z])/g, " $1").trim();
  }

  if (name === INVOICE_ACCOUNT_NAME) {
    return `Manual Bank Account (${account.numbers.account.slice(-4)})`;
  }

  if (institution && formattedSubType && mask) {
    return `${institution} ${formattedSubType} (${mask})`;
  }
  if (institution && formattedSubType) {
    return `${institution} ${formattedSubType}`;
  }
  return name;
};

export const getAccountSubName = (account: IAccount): string => {
  const { subType, mask, name } = account;
  let formattedSubType;
  if (subType) {
    formattedSubType = subType.replace(/([A-Z])/g, " $1").trim();
  }

  if (formattedSubType && mask) {
    return `${formattedSubType} (${mask})`;
  }
  if (formattedSubType) {
    return formattedSubType;
  }
  return name;
};

export const getDebitCardName = (debitCard: ICheckbookCard | undefined) => {
  if (debitCard?.last4) {
    return `Debit Card (${debitCard.last4})`;
  }
  return "Debit Card";
};

export const getCreditCardBrandDisplayName = (ccBrand: string): string => {
  let displayName = "";
  switch (ccBrand) {
    case "amex":
      displayName = "American Express";
      break;
    case "discover":
      displayName = "Discover";
      break;
    case "jcb":
      displayName = "JCB";
      break;
    case "mastercard":
      displayName = "MasterCard";
      break;
    case "unionPay":
      displayName = "UnionPay";
      break;
    case "visa":
      displayName = "Visa";
      break;
    case "unknown":
    default:
  }
  return displayName;
};
